import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, InputAdornment, SxProps, useTheme } from "@mui/material";
import { ChangeEvent, FormEvent, useState } from "react";
import { GeneralButtonLabel } from "../../data/texts";
import { VoidFunction } from "../../models/common.models";
import StyledTextField from "../../styled-cmps/input-submit";
interface InputSubmitProps {
  input?: { placeholder: string };
  button?: { label: string };
  containerSx?: SxProps;
  onInput?: (value: string) => void;
  handleSubmit: VoidFunction;
  disabled?: boolean;
}

const InputSubmit = ({ input, containerSx, button, onInput, handleSubmit, disabled }: InputSubmitProps) => {
  const theme = useTheme();
  const [inputValue, setInputValue] = useState("");

  const onInputChange = (ev: ChangeEvent<HTMLInputElement>) => {
    if (onInput) {
      const value = ev.target.value;
      setInputValue(value);
      onInput(value);
    }
  };

  const onCleanInput = () => {
    onInput?.("");
    setInputValue("");
  };

  const onSubmit = (ev: FormEvent) => {
    ev.preventDefault();
    handleSubmit();
  };
  return (
    <Box
      onSubmit={onSubmit}
      component={"form"}
      sx={{
        display: "flex",
        gap: "16px",
        ...containerSx,
      }}
    >
      <StyledTextField
        onChange={onInputChange}
        value={inputValue}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment sx={{ cursor: "pointer" }} onClick={onCleanInput} position="end">
                <CloseIcon />
              </InputAdornment>
            ),
          },
        }}
        placeholder={input?.placeholder}
      />
      <Button
        disabled={disabled}
        type="submit"
        variant="contained"
        sx={{
          flexGrow: 1,
          background: theme.palette.text.primary,
          borderRadius: "8px",
          fontSize: "17px",
          "&.Mui-disabled": {
            background: theme.palette.text.primary,
            opacity: 0.5,
            color: "white",
          },
        }}
      >
        {button?.label || GeneralButtonLabel.SUBMIT}
      </Button>
    </Box>
  );
};

export default InputSubmit;
